/* eslint-disable */
export default {
  namespaced: true,
  state: {
    keywords: {},
  },
  getters: {
    keywords: (state) => state.keywords,
  },
  mutations: {
    setKeyword(state, data) {
      const { conversationId, keyword } = data;
      if (!state.keywords[conversationId]) {
        state.keywords[conversationId] = [];
      }
      const isExist = state.keywords[conversationId].find(i => i.id === keyword.id);
      if (!isExist) {
        state.keywords[conversationId].push(keyword);
      }
    },
  },
};
